import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { TagsService } from '../tags/services/tags.service';
import { Tag, TagsUsage } from '../tags/models';

import { DateTimeService } from '../shared/datetime/datetime.service';
import { GenericModalService, ModalSettingsInput, ModalMultiButton, ModalSettingsMessage } from '../shared/generic-modal/generic-modal.service';
import { CurrentUserService } from '../user/services/current-user.service';
import { ToastService, ToastType } from '../shared/toast/toast.service';
import { SvgIconComponent } from '../shared/icons/svg-icon.component';
import { PermissionRequiredDirective } from '../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../shared/grid/biz-grid.directive';
import { DxoEditingModule, DxoColumnFixingModule, DxiColumnModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
@Component({
    templateUrl: './partner-tags.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoColumnFixingModule, DxiColumnModule, DxiButtonModule, DxTemplateModule]
})

export class PartnerTagsComponent implements OnInit {

    constructor(private tagsService: TagsService, private toastService: ToastService, private currentUserService: CurrentUserService,
        public dateTimeService: DateTimeService, private genericModalService: GenericModalService) { }

    public tags: Tag[] = [];
    public isLoading: boolean = false;

    public allowUpdating = false;
    public allowAdding = false;
    public allowDeleting = false;
    public allowShowLog = false;

    ngOnInit(): void {
        this.allowUpdating = this.currentUserService.hasPermission('Settings_Action_Settings_Edit');
        this.allowDeleting = this.currentUserService.hasPermission('Settings_Action_Settings_Delete');
        this.allowAdding = this.currentUserService.hasPermission('Settings_Action_Settings_Create');
        this.allowShowLog = this.currentUserService.hasPermission('Settings_Action_Settings_ShowLog');

        this.refresh();
    }

    initNewRow(e: any) {
        e.data = new Tag(TagsUsage[TagsUsage.Partner]);
    }

    createTag(e: any) {
        var tag: Tag = new Tag(TagsUsage[TagsUsage.Partner]);
        Object.assign(tag, e.data);
        this.saveTag(e, tag, 'Tag created...')
    }

    refresh() {
        this.isLoading = true;
        this.tagsService.getTags(TagsUsage.Partner).then(tags => {
            this.tags = tags;
            this.isLoading = false;
        });
    }

    updateTag(e: any) {
        Object.assign(e.key, e.newData);
        this.saveTag(e, e.key, 'Tag saved...')
    }

    deleteTag(e: any) {
        var deferred = $.Deferred();
        e.cancel = deferred.promise();

        this.tagsService.deleteTag(e.data.Id, false, false).then(() => {
            deferred.resolve();
            this.toastService.showToast('Tag deleted...', ToastType.success);
        }).catch(() => {
            this.genericModalService.confirmDirect('Delete', 'The tag is in use. Do you really want to delete it?', 'Yes', 'No').then(() => {
                this.tagsService.deleteTag(e.data.Id, true, true).then(() => {
                    deferred.resolve();
                    this.toastService.showToast('Tag deleted...', ToastType.success);
                }).catch(() => deferred.reject());
            }).catch(() => {
                deferred.resolve();
                this.refresh(); // TODO: Find a way to cancel with a promise.
            });
        });
    }

    saveTag(e: any, tag: Tag, toast: string) {
        var deferred = $.Deferred();
        e.cancel = deferred.promise();
        this.tagsService.saveTag(tag).then((saved) => {
            if (e.data) {
                Object.assign(e.data, saved);
            }
            else if (e.key) {
                Object.assign(e.key, saved);
            }
            deferred.resolve();
            this.toastService.showToast(toast, ToastType.success);
        }).catch(() => deferred.reject());
    }
}

